import React, { useState } from "react";
import ReadOnlyField from "components/attributes/compare-table/read-only-field";
import { QaOverride } from "./qa-override";
import { QAButtons } from "./qa-buttons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

import "components/attributes/compare-table/compare-table.scss";
import { useTask } from "../../../shared/hooks/use-task";
import { useAttributes } from "../../../shared/hooks/use-attributes";

export const QAColumn = ({
    roleLabels,
    role,
    attr,
    readOnlyOverride,
    highlightRow,
    highlightCell,
    qaAttributes,
    refetchCoderRoles,
    qaEdit,
    showQaEdit,
    hasRedo,
    isReadOnlyEdit,
}) => {
    const { task } = useTask();
    const { cancelUpdate } = useAttributes();
    const highlightQA = highlightCell && !hasRedo ? "-highlight" : "";
    const [oldData, setOldData] = useState(qaAttributes);

    const toggleQaEdit = () => {
        showQaEdit(!qaEdit);
    };

    const handleRefreshAttributes = () => {
        refetchCoderRoles();
        toggleQaEdit();
    };

    const handleCancel = () => {
        cancelUpdate(attr, oldData[attr.uuid]);
        toggleQaEdit();
        setOldData(qaAttributes);
    };

    if (qaEdit) {
        return (
            <QaOverride
                attr={attr}
                readOnlyOverride={readOnlyOverride}
                onCancel={handleCancel}
                onRefresh={handleRefreshAttributes}
                qaAttributes={qaAttributes}
            />
        );
    }

    if (highlightRow && !qaAttributes[attr.uuid] && qaAttributes[attr.uuid] !== false && !task.isCompleted) {
        return (
            <QAButtons
                roleLabels={roleLabels}
                attr={attr}
                task={task}
                refetchCoderRoles={refetchCoderRoles}
                toggleQaEdit={toggleQaEdit}
                hasRedo={hasRedo}
                disabled={isReadOnlyEdit}
            />
        );
    }

    return (
        <div
            key={`AIF_${attr.uuid}_${role.label}`}
            className={`coder-attributes-container justify-content-between ${highlightQA}`}
        >
            <ReadOnlyField
                id={attr.uuid}
                value={role.attributes[attr.uuid]}
                defaultValue={attr.defaultValue}
                attribute={attr}
                readOnlyOverride={readOnlyOverride}
                wipKey={task.context.codingWipKey}
                taskType={task.taskType}
                roleType={role.type}
                roleLabel={role.label}
            />
            {!task.isCompleted && (
                <button
                    aria-label="edit"
                    className="button -text align-right"
                    onClick={toggleQaEdit}
                    disabled={hasRedo || isReadOnlyEdit}
                >
                    <FontAwesomeIcon icon={faEdit} />
                </button>
            )}
        </div>
    );
};
